import { render, staticRenderFns } from "./keduaMobile.vue?vue&type=template&id=1b0edc58&scoped=true&"
import script from "./keduaMobile.vue?vue&type=script&lang=js&"
export * from "./keduaMobile.vue?vue&type=script&lang=js&"
import style0 from "./keduaMobile.vue?vue&type=style&index=0&id=1b0edc58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0edc58",
  null
  
)

export default component.exports